import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";

import HeaderComponent from "./Header";

import { useAppDispatch, useAppSelector } from "@/hooks";

import { setCookieStorage, getCookieStorage } from "@/utils";

import * as actions from "@/redux/AuthReducer";
import * as dashboardActions from "@/redux/DashboardReducer";

interface HeaderPropsI {
  hideLinks?: boolean;
  darkHeader?: boolean;
  headerBackgroundColor?: string;
  isStickyHeader?: boolean;
  isLandingPage?: boolean;
  hideRibbon?: boolean;
  appDownloadLink?: string;
  headerRef?: React.Ref<HTMLElement>;
  isShyftPassBookingPage?: boolean;
  windowWidth?: number;
}

const Header: React.FC<HeaderPropsI> = ({
  hideLinks = false,
  hideRibbon,
  isShyftPassBookingPage,
  ...rest
}) => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const { isRibbonDataLoading, ribbonDataError, ribbonData } = useAppSelector(
    (state) => state.dashboard
  );

  const { countryCodeData: countryCodes } = useAppSelector(
    (state) => state.dashboard
  );

  const loginData = useAppSelector((state) => state.auth) || {};

  const [showSidebar, setShowSidebar] = useState(false);
  const [login, setLogin] = useState(false);
  const [loginModal, setLoginModal] = useState(false);
  const [token, setToken] = useState(null);
  const [showToast, setShowToast] = useState(false);

  const showRibbon =
    !hideRibbon && !isRibbonDataLoading && !ribbonDataError && ribbonData;

  const status = loginData?.isLoggingIn;

  useEffect(() => {
    if (token || (loginData?.data?.access && loginData?.data?.refresh)) {
      setCookieStorage("__authAccessToken", loginData?.data?.access, 30);
      setCookieStorage("__authRefreshToken", loginData?.data?.refresh, 90);
      if (loginData?.data?.primaryContact)
        setCookieStorage(
          "__primaryContact",
          loginData?.data?.primaryContact,
          90,
          "days"
        );
    }
  }, [status]);

  useEffect(() => {
    if (
      getCookieStorage("__authAccessToken") !== "" &&
      getCookieStorage("__authRefreshToken") !== ""
    ) {
      setToken(true);
      setLogin(true);
    } else {
      setLogin(false);
      setToken(false);
    }
  }, [status]);

  const Logout = () => {
    setLogin(false);
    setToken(false);
    dispatch(actions.logout());
    setShowToast({
      type: "success",
      message: "Logout Successful",
    });
    window.history.replaceState(null, "", "/");
  };

  const pathname = router?.asPath?.split("?")?.[0];
  useEffect(() => {
    if (!hideRibbon) {
      dispatch(dashboardActions.getRibbonData({ pathname }));
    }
  }, [dispatch, pathname, hideRibbon]);

  const setLoginToken = (state) => {
    setToken(state);
  };

  return (
    <HeaderComponent
      hideLinks={hideLinks}
      showSidebar={showSidebar}
      setShowSidebar={setShowSidebar}
      token={token}
      Logout={Logout}
      setLoginModal={setLoginModal}
      showRibbon={showRibbon}
      ribbonData={ribbonData}
      showToast={showToast}
      setShowToast={setShowToast}
      login={login}
      loginModal={loginModal}
      setLoginToken={setLoginToken}
      countryCodes={countryCodes}
      router={router}
      isShyftPassBookingPage={isShyftPassBookingPage}
      {...rest}
    />
  );
};

export default Header;
